"use client";

export interface VehicleRecommendedDestinationsProps {
  destinations: string;
}

export function VehicleRecommendedDestinations({
  destinations,
}: VehicleRecommendedDestinationsProps) {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-bold mb-4">Recommended Destinations</h3>
      <p className="text-muted-foreground text-lg">{destinations}</p>
    </div>
  );
}
